module.exports = __webpack_public_path__ + "static/media/hero.fb9c7d69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/hero.jpg
// module id = 814
// module chunks = 0